import { render, staticRenderFns } from "./OrderFeedback.vue?vue&type=template&id=6f8b3654&scoped=true&"
import script from "./OrderFeedback.vue?vue&type=script&lang=ts&"
export * from "./OrderFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./OrderFeedback.vue?vue&type=style&index=0&id=6f8b3654&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b3654",
  null
  
)

export default component.exports